import { ReactSVG } from 'react-svg';
import styled from 'styled-components';

const StyledSideMenu = styled.menu`
  height: 100%;
  width: 248px;
  background-color: ${({ theme }) => theme.colors.mainColorContrast};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 32px;
`;

const Logo = styled.img`
  height: 52px;
  width: 168px;
  margin-bottom: 24px;
`;

const NotificationDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.mainColor};
  position: absolute;
  right: 24px;
`;

const MenuOption = styled.button`
  position: relative;
  width: 100%;
  min-height: 55px;
  padding-left: 16px;
  display: flex;
  align-items: center;

  cursor: pointer;

  background-color: ${({ active, theme }) => (active ? theme.colors.mainColorContrastDarker : 'transparent')};
  border: none;

  p {
    text-align: left;
    ${({ theme }) => theme.typograph.subTitle};
    color: ${({ theme }) => theme.colors.contrastColorBackground};
  }

  svg {
    height: 24px;
    width: 24px;
    margin-right: 12px;
  }

  &:hover {
    background: linear-gradient(90deg, #2A334D -40.73%, rgba(42, 51, 77, 0) 90.73%);
  }

  &:disabled {
    p {
      color: ${({ theme }) => theme.colors.mainColorContrastDarker};
    }

    svg path {
      stroke: ${({ theme }) => theme.colors.mainColorContrastDarker};
      fill: ${({ theme }) => theme.colors.mainColorContrastDarker};
    }

    :hover {
      cursor: not-allowed;
    }
  }
`;

const MenuOptionWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MenuOptionIcon = styled(ReactSVG)`
  width: 24px;
  height: 24px;
  margin-right: 16px;
`;

const Divider = styled.div`
  width: 168px;
  height: 1px;

  background-color: ${({ theme: { colors } }) => colors.mainColorContrastDarker};
  border: none;
  margin-top: 12px;
  margin-bottom: 12px;
`;

export {
  StyledSideMenu,
  Logo,
  MenuOption,
  Divider,
  MenuOptionWrapper,
  MenuOptionIcon,
  NotificationDot,
};
